import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"

const RegisterLock = function (props) {
  const { message } = props
  return <BlankSlate icon="lock" body={message} />
}

RegisterLock.defaultProps = { message: "Registration currently unavailable." }

RegisterLock.displayName = "RegisterLock"

export default RegisterLock
